import { ApolloError, FetchResult, MutationFunctionOptions } from '@apollo/client';
import { SubmitBetMutation, SubmitBetMutationVariables, useSubmitBetMutation } from './gql/submitBet.generated';

type TUseSubmitBet = () => {
  loading: boolean;
  submitBet: (
    options?: MutationFunctionOptions<SubmitBetMutation, SubmitBetMutationVariables>,
  ) => Promise<FetchResult<SubmitBetMutation>>;
  error: ApolloError | undefined;
};

export const useSubmitBet: TUseSubmitBet = () => {
  const [submitBet, { loading, error }] = useSubmitBetMutation();

  const wrappedSubmitBet = async (options?: MutationFunctionOptions<SubmitBetMutation, SubmitBetMutationVariables>) => {
    try {
      const result = await submitBet(options);
      return result;
    } catch (err) {
      console.error('❌ [GraphQL] submitBet mutation failed:', err);
      throw err;
    }
  };

  return {
    loading,
    submitBet: wrappedSubmitBet,
    error,
  };
};
